import React, {useState} from "react";
import {useIntl} from "react-intl";
import {usePWAInstall} from 'react-use-pwa-install';
import {isMobile, isIOS} from 'react-device-detect';
import Modal from "../ui-components/Modal";
import {ArrowUpOnSquareIcon, PlusSmallIcon} from "@heroicons/react/24/outline";
import _ from "lodash";
import {ArrowDownTrayIcon, XMarkIcon} from "@heroicons/react/24/solid";


const PWA_HIDE_HEADER_LSKEY = 'pwa-header-hidden';
const SHOW_HIDDEN_HEADER_AFTER_DAYS = 7;


const PWAInstallationHeader = () => {

  const intl = useIntl();
  const [isHidden, setIsHidden] = useState(false);
  const [isIOSModalVisible, setIsIOSModalVisible] = useState(false);

  // hooks
  const install = usePWAInstall();  // will return null if PWA is not correctly set up or if already installed

  if (!isMobile)
    return null;

  let action;
  if (install)
    action = install;
  else if (isIOS && !window.navigator.standalone === true)
    action = () => { setIsIOSModalVisible(true); }
  else
    return null;

  const hiddenOn = localStorage.getItem(PWA_HIDE_HEADER_LSKEY);
  const hiddenOnDaysDiff = hiddenOn
    ? Math.ceil((new Date() - Date.parse(hiddenOn))  / (1000 * 60 * 60 * 24))
    : null;

  return <>
    {
      (!hiddenOnDaysDiff || hiddenOnDaysDiff > SHOW_HIDDEN_HEADER_AFTER_DAYS) && !isHidden && (
        <div className="flex items-center justify-center gap-4 p-6 bg-black pr-10 text-white sm:text-base relative">
          <ArrowDownTrayIcon className="w-8" style={{minWidth: "2rem"}} />
          <span>
            {intl.formatMessage({id: 'pwa_installation_alert'})}
            <span className="underline font-semibold cursor-pointer ml-1" onClick={action}>
              {intl.formatMessage({id: 'click_here_to_install'})}
            </span>
          </span>
          <XMarkIcon
            className="w-5 absolute right-4 cursor-pointer"
            style={{minWidth: "1.25rem"}}
            onClick={() => {
              localStorage.setItem(PWA_HIDE_HEADER_LSKEY, new Date());
              setIsHidden(true);
            }}
          />
        </div>
      )
    }
    {
      isIOSModalVisible && (
        <Modal
          onExit={() => { setIsIOSModalVisible(false); }}
        >
          <h3 className="font-extrabold text-lg text-center">
            {intl.formatMessage({id: 'install_app'})}
          </h3>
          <p className="mt-6">
            {intl.formatMessage({id: 'install_app_helper'})}
          </p>
          <p className="my-2">
            <span className="font-extrabold">{intl.formatMessage({id: 'note'})}</span>:
            <span className="ml-1">
              {intl.formatMessage({id: 'install_app_helper_safari_note'}, {browser: <span className="font-bold">Safari</span>})}
            </span>
          </p>
          <ol className="list-decimal my-5 leading-5 px-5">
            <li className="mb-1.5">
              {
                intl.formatMessage(
                  {id: 'ios_pwa_click_on_share_btn'},
                  {
                    target: <span className="font-bold">
                      <ArrowUpOnSquareIcon className="w-5 mr-0.5 inline-block text-blue-400" />
                      <span>{_.capitalize(intl.formatMessage({id: 'share'}))}</span>
                    </span>
                  }
                )
              }
            </li>
            <li className="mb-1.5">
              {
                intl.formatMessage(
                  {id: 'ios_pwa_click_on_add_to_home_btn'},
                  {
                    target: <span className="font-bold ml-0.5">
                      <PlusSmallIcon className="w-4 inline border border-am-500 rounded mx-0.5" />
                      <span className="ml-1">{intl.formatMessage({id: 'add_to_home_screen'})}</span>
                    </span>
                  }
                )
              }
            </li>
            <li>
              {
                intl.formatMessage(
                  {id: 'ios_pwa_click_on_add'},
                  {
                    target: <span className="font-bold">
                      {intl.formatMessage({id: 'add'})}
                    </span>
                  }
                )
              }
            </li>
          </ol>
          <p className="mt-6">
            {intl.formatMessage({id: 'install_app_conclusion'})}
          </p>
        </Modal>
      )
    }
  </>
}

export default PWAInstallationHeader;